<template>
  <vue-apex-charts
    class="tkcBarChart"
    ref="trendkeywordChartBar"
    :height="barChartHeight"
    v-on:update:heightSetting="setHeight"
    :options="chartOptionsBar"
    :series="series"
  />
</template>

<script>
import VueApexCharts from "vue-apexcharts";

const colorMap = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", 
                  "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", 
                  "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", 
                  "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"];

export default {
  name: "TrendKeywordChartBar",
  components: {
    VueApexCharts,
  },
  data() {
    return {
      barChartHeight: 39.67*21,
      chartOptionsBar: {
        chart: {
          type: "bar",
          // background: '#FBFBFB',
          toolbar:{
            show: false
          },
          sparkline:{
            enabled: true
          }
        },
        grid:{
          show: true,
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: ['스타벅스', '네스프레소'],
        },
        yaxis: {
          labels: {
            show: false,
          }
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          bar: {
            barHeight: '90%',
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom',
            },
          }
        },
        noData: {
          text: '분석중...',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#1817E7',
            fontSize: '20px',
            fontFamily: "NanumBarunGothicB",
          }
        },
        // noData: {
        //   text: '해당하는 키워드가 없습니다.',
        //   style: {
        //     color: '#FF009C',
        //   }
        // },
        colors: [
          function({ value, seriesIndex, w }) {
            if(w.globals.labels[seriesIndex] == 'NONBRANDED')
              return '#bfbfbf';
            else
              return '#A5BFFF';
          }
        ],
      },
      series: [{
        data: []
      }],
    };
  },
  props: {
    barChartData: {
      type: Array,
      default: () => [],
    },
    barChartCategory: {
      type: Array,
      default: () => [],
    },
    barChartDiff: {
      type: Array,
      default: () => [],
    },
    barChartNodata: {
      type: Number,
      default: 1,
    }
  },
  watch: {
    barChartData() {
      const newData = []
      for (const data of this.barChartData) {
        newData.push(data);
      }
      const newCategory = []
      for (const data of this.barChartCategory) {
        newCategory.push(data);
      }
      const newDiff= []
      for (const data of this.barChartDiff) {
        newDiff.push(data);
      }
      if(newCategory.length > 0){
        this.setHeight(39.67*newCategory.length, newData, newCategory, newDiff)
      }
      if(this.barChartNodata == 0){
        this.setNodata()
      }else{
        this.setYesdata()
      }

    },
    // barChartNodata() {
    //   console.log('test')
    //   console.log(this.barChartNodata)
    //   if(this.barChartNodata == 0){
    //     this.setNodata()
    //   }else{
    //     this.setYesdata()
    //   }
    // },
  },

  methods:{
    setNodata(){
      console.log('no data!!!!!!!!!!!!!!!!!!!!!!!!!!')
      this.series = [{
        data: [],
      }]    
      this.barChartHeight = 600
      this.chartOptionsBar = {
        ...this.chartOptionsBar,
        ...{
              noData: {
                text: '해당하는 키워드가 없습니다.',
                style: {
                  color: '#FF009C',
                }
              },         
            }
      }
    },
    setYesdata(){
      this.chartOptionsBar = {
        ...this.chartOptionsBar,
        ...{
              noData: {
                text: '분석중...',
                align: 'center',
                verticalAlign: 'middle',
                offsetX: 0,
                offsetY: 0,
                style: {
                  color: '#1817E7',
                  fontSize: '20px',
                  fontFamily: "NanumBarunGothicB",
                }
              },       
            }
      }
    },
    setHeight(value, newData, newCategory, newDiff) {
      console.log('--- setHeight ---')
      console.log(value)
      this.barChartHeight = value
      this.setValues(newData, newCategory, newDiff)
    },
    setValues(newData, newCategory, newDiff){
      console.log('--- setValues ---')
      this.series = [{
        data: newData,
      }]    
      this.chartOptionsBar = {
        ...this.chartOptionsBar,
        ...{
              chart: {
                type: "bar",
                background: '#FBFBFB',
                toolbar:{
                  show: false
                },
                sparkline:{
                  enabled: true
                },
                events: {
                  dataPointSelection: function(event, chartContext, opt) {
                    opt.w.globals.dom.baseEl.__vue__.$store.dispatch('callTrendKeyword', { selKeyword: opt.w.globals.labels[opt.dataPointIndex] })
                  }
                }
              },
              xaxis:{
                categories: newCategory,
              },
              dataLabels: {
                enabled: true,
                fontFamily: "NanumBarunGothic !important",
                textAnchor: 'middle',
                style: {
                  colors: ['#444']
                },
                offsetX: 0,
                offsetY: 0,
                dropShadow: {
                  enabled: true,
                  top: 3,
                  left: 3,
                  blur: 0,
                  color: '#FF0',
                  opacity: 1
                },
                formatter: function (val, opt) {
                  var freq = parseFloat(val).toLocaleString()
                  return opt.w.globals.labels[opt.dataPointIndex] + ":  " + freq
                },
              },
              plotOptions: {
                bar: {
                  barHeight: '90%',
                  distributed: true,
                  horizontal: true,
                  dataLabels: {
                    position: 'bottom',
                  },
                }
              },              
            }
      }
      this.$refs.trendkeywordChartBar.updateOptions(this.chartOptionsBar, true);

    }
  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";

// .tkcBarChart .apexcharts-canvas .apexcharts-datalabel {
//   margin-left: 100px;
//   font-weight: 100;
//   font-size: 20px;
// }

</style>
